import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const TejaxoCRM = ({ location }) => {
    //const loc = location ? `in ${location}` : '';

    //document.title = `Best CRM Software ${loc} | CRM Systems | Business Management Solutions - Tejaxo Software`;
    //document.querySelector('meta[name="description"]').setAttribute(
    //    'content',
    //    `Tejaxo CRM Software is a High Rated CRM Software ${loc}, providing Barcode based automatic Production Enterprise Resource Planning (ERP) software ${loc}, business management solutions, services and support.`
    //);
    //document.querySelector('meta[name="keywords"]').setAttribute(
    //    'content',
    //    `Tejaxo CRM Software ${loc}`
    //);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
            <div className="container">
                <div className="row">
                    <img src="/theme/img/bdimg11.JPG" alt="CRM Overview" />
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <h2 className="elementor-heading-title elementor-size-default">
                            Customers have ever-escalating service expectations...
                            <br />
                        </h2>
                    </div>
                    <div className="col-lg-6 content">
                        <img src="/theme/img/bdimg12.JPG" alt="Customer Expectations" />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-lg-6 about-img">
                        <img src="/theme/img/image2-Tejaxo-xi-crm-768x512.jpg" alt="Tejaxo Xi CRM" />
                    </div>
                    <div className="col-lg-6 content">
                        <h3 className="elementor-heading-title elementor-size-default">
                            You need a solution that supports your journey towards an omni-channel experience.
                        </h3>
                        <p>
                            <span style={{ fontWeight: 400 }}>
                                One that turns simple transactions into valuable customer insights. One that brings all your customer data together to create one, single view so you can see them, know them, and serve them individually � en masse. Tejaxo Xi CRM is a solution that keeps all aspects of your customer relationships in focus, nurtures relationships, and drives real customer satisfaction.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            </section>
        </MasterPage>
    );
};

export default TejaxoCRM;